import React from "react";
import { VEB_PLAN_NAME, VEB_PLAN_NAMES } from "../../../constants/plan";
import KemperStackWholeLifeInsuaranceForm from "./plans/kemper/wholeLife/stackForm/KemperStackWholeLifeInsuaranceForm";
import KemperStackFormCriticalIllness from "./plans/kemper/criticalIllness/stackForm/KemperStackFormCriticalIllness";

const StackForm = ({
	onClose,
	VEBOpenEnrollment,
	getVEBEnrollmentInitData,
	planName,
	vebBenefits
}: // VEBEnrollments
any): JSX.Element => {
	// console.log("planName", planName, planName == VEB_PLAN_NAMES.whole_life);
	return (
		<>
			{planName == VEB_PLAN_NAMES.whole_life ? (
				<KemperStackWholeLifeInsuaranceForm
					vebBenefits={vebBenefits}
					onClose={onClose}
					VEBOpenEnrollment={VEBOpenEnrollment}
					getVEBEnrollmentInitData={getVEBEnrollmentInitData}
				/>
			) : planName == VEB_PLAN_NAMES.critical_illness ? (
				<KemperStackFormCriticalIllness
					vebBenefits={vebBenefits}
					onClose={onClose}
					VEBOpenEnrollment={VEBOpenEnrollment}
					getVEBEnrollmentInitData={getVEBEnrollmentInitData}
				/>
			) : (
				<></>
			)}
		</>
	);
};

export default StackForm;
